import * as Sentry from '@sentry/angular';

export class SentryService {
    public captureException(error, callback?): string {
        return Sentry.captureException(error, callback);
    }
}
